import { ProjectDetail } from 'types/Modal';
import { project0 } from './project0';
import { project1 } from './project1';

export const projectDetailData: ProjectDetail[] = [project0, project1];
